// extracted by mini-css-extract-plugin
export default {"container":"DHhhp","extraMarginTop":"_2xl7N","badgeContainer":"_3rvD1","badge":"_3edxa","date":"_3EBFz","time":"_1Fk0q","separator":"IylVA"};